export default __webpack_public_path__ + "static/RPF-Logo-Footer-264f5575bd1a0fc7c393179aaec66fff.webp";